const styles = (theme) => ({
  // Container principal do formulário
  paper: {
    padding: { xs: "20px", md: "30px" },
    borderRadius: "16px",
    height: "100%",
    display: "flex",
    flexDirection: "column",
  },
  textfield: {
    width: "100%",
  },
  // Container cinza de fundo da área de preview
  previewContainer: {
    padding: "20px",
    borderRadius: "16px",
    //backgroundColor: "#e0e0e0", // Fundo mais escuro para destacar a folha branca
    display: "flex",
    justifyContent: "center",
    alignItems: "flex-start", // Alinha a folha ao topo
    minHeight: "600px",
    overflow: "auto", // Scroll se a tela for pequena demais
  },
  // A Folha A4
  previewPaper: {
    backgroundColor: "#fff",
    width: "100%",
    maxWidth: "500px", // Largura controlada para não ficar gigante em telas wide
    aspectRatio: "210 / 297", // Proporção Exata A4
    padding: "30px", // Margens da impressão
    boxShadow: "0px 4px 20px rgba(0,0,0,0.15)",
    position: "relative",
    display: "flex",
    flexDirection: "column",
  },
  // Linha superior do cabeçalho (Logo + Dados)
  previewTopRow: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-start",
    gap: 2,
    marginBottom: "10px",
  },
  previewLogoContainer: {
    width: "25%",
    maxWidth: "150px",
    display: "flex",
    alignItems: "center",
  },
  previewLogo: {
    width: "100%",
    height: "auto",
    maxHeight: "60px",
    objectFit: "contain",
  },
  // Dados da empresa alinhados à direita
  previewCompanyInfo: {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-end",
    textAlign: "right",
  },
  // Linha de contatos centralizada
  previewContactRow: {
    textAlign: "center",
    color: "#333",
    fontSize: "10px",
    mt: -1,
  },
  // Marca d'água centralizada na folha
  watermark: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%) rotate(-45deg)",
    fontSize: { xs: "50px", sm: "80px" },
    fontWeight: 600,
    color: theme.palette.primary.main,
    opacity: 0.3,
    whiteSpace: "nowrap",
    pointerEvents: "none",
    zIndex: 0,
  },
});

export default styles;
